import React from 'react';
import { Form } from 'react-bootstrap';
import './InvoiceDetails.css';

export const validInvoiceDetails = value => value && ['email','address','postalCode','city'].every(key => value[key]?.trim()) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email);

const fields = [
    ['email', 'E-postadress för fakturor', 'email', 'email', true],
    ['address', 'Företagets postadress', 'text', 'street-address', true],
    ['postalCode', 'Postnummer', 'text', 'postal-code', false],
    ['city', 'Ort', 'text', 'address-level2', false],
];

export default function InvoiceDetails({ value = {}, onChange, disabled, days = 14 }) {
    return <fieldset disabled={disabled} className="invoice-details">
        <legend>Fakturauppgifter</legend>
        <p className="invoice-details-intro">Fakturan skapas och skickas av Stripe för LedgerLoop AB:s räkning. Den kommer via e-post i svenska kronor och betalas till vårt bankkonto. Betalningsvillkor: {days} dagar. Ange fakturanumret som referens.</p>
        <div className="invoice-details-grid">
            {fields.map(([key, label, type, autoComplete, wide]) =>
                <Form.Group key={key} controlId={`invoice-${key}`} className={`invoice-details-field${wide ? ' invoice-details-field--wide' : ''}`}>
                    <Form.Label>{label}</Form.Label>
                    <Form.Control type={type} required autoComplete={autoComplete} maxLength={key === 'postalCode' ? 20 : 254} value={value[key] || ''}
                        onChange={event => onChange({ ...value, [key]: event.target.value })} />
                </Form.Group>)}
        </div>
        <p className="invoice-details-note">Uppgifterna sparas som företagets kontakt- och adressuppgifter. Åtkomsten fortsätter till förfallodagen och pausas om betalningen inte har registrerats då.</p>
    </fieldset>;
}
